'use client';

import GoogleOneTap from '@alltrails/layout/components/GoogleOneTap';
import useBraze from '@alltrails/layout/hooks/useBraze';
import useOsano from '@alltrails/layout/hooks/useOsano';
import useTinuitiPixel from '@alltrails/layout/hooks/useTinuitiPixel';
import AmplitudeBrowserSdk from '@alltrails/layout/scripts/AmplitudeBrowserSdk';
import { useCaptureSessionAttribution } from '@alltrails/session-storage';
import { DatadogRumScript } from '@alltrails/stability';
import ReturningUserUpsell from '@alltrails/upsell/components/ReturningUserUpsell/ReturningUserUpsell';
import useAppleRedirectHandler from '@alltrails/user-auth/hooks/useAppleRedirectHandler';

const LocationPageAnalytics = ({ moveLocationMobileMapExpValue }: { moveLocationMobileMapExpValue?: string }) => {
  useOsano();
  useTinuitiPixel();
  useBraze();
  useAppleRedirectHandler();
  useCaptureSessionAttribution();

  return (
    <>
      <DatadogRumScript moveLocationMobileMapExpValue={moveLocationMobileMapExpValue} />
      <AmplitudeBrowserSdk />
      <GoogleOneTap pageViewLimitReached={false} />
      <ReturningUserUpsell />
    </>
  );
};

export default LocationPageAnalytics;
